import { useState, useEffect, useRef } from 'react' 
import { message } from 'antd'
import { useSelector } from 'react-redux'
import YzBackgroundMobile from '../../../../../components/mobile/YzBackgroundMobile'
import YzExhibitionRowMobile from '../../../../../components/mobile/YzExhibitionRowMobile'
import FooterMobile from '../../../../../components/mobile/FooterMobile'
import BuoyBoxMobile from '../../../../../components/mobile/BuoyBoxMobile'
import YzEmptyMobile from '../../../../../components/mobile/YzEmptyMobile'
import HTTP from '../../../../../utils/Http'
import './index.less'

const CDSectionMobile = () => {
  // 菜单
  const menuList = useSelector((state) => state?.Menu?.menuList) // 菜单列表
  const [backgroud] = menuList.filter(f => f.title === '核心业务').map(m => m.backgroud)

  const [data, setData] = useState([]) // 定制开发列表
  const [loading, setLoading] = useState(false)
  const getData = async () => {  // 获取定制开发列表
    if (loading) return;
    setLoading(true)
    try {
      const res = await HTTP.postForm("/api/v1/solution/coreBusiness"+`?t=${new Date().getTime()}`);
      if (res.status === 10000) {
          setData(res?.data);
      } else {
        message.error({ content: res?.message, style: { marginTop: '10vh' } })
      }
    } catch (error) {
      message.error({ content: '通信失败，请检查网络后重试', style: { marginTop: '10vh' } })
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  // 置顶
  const boxRef = useRef(null)
  const [scrollTop, setScrollTop] = useState(0)
  const [clientHeight, setClientHeight] = useState(0)
  const goToTop = () => { // 置顶事件
    let myTimer = setInterval(() => {
      boxRef.current.scrollTop -= 60
      if(boxRef.current.scrollTop<=0){
        boxRef.current.scrollTop = 0
        window.clearInterval(myTimer)
      }
    }, 10)
  }
  useEffect(() => { // 页面滚动
    window.addEventListener("scroll", (e) => {
      setScrollTop(e?.target?.scrollTop)
      setClientHeight(e?.target?.clientHeight);
    }, true)
  }, [])

  return (
    <section ref={boxRef} className='cds_section_m'>
      <div className='cds_box_m'>
        <YzBackgroundMobile
          title='Core Business'
          content='核心业务'
          backgroundImage={backgroud}
          isShowButton={false}
        />
        {
          data &&
          data?.length > 0 ?
          data?.map((m, index) =>
            <YzExhibitionRowMobile
              key={'yz_exhibition_row_'+index}
              index={index}
              title={m?.title}
              viceTitle={m?.content}
              icon={m?.pic2}
              backgroundColors={['#FAFAFA', '#FFF']}
              btnTitle='立即咨询'
            />
          ) :
          <div style={{ flex: 1 }}>
            <YzEmptyMobile />
          </div>
        }
        <FooterMobile isAbout={false} />
        <BuoyBoxMobile isShowTop={scrollTop > clientHeight} onTop={goToTop} />
      </div>
    </section>
  )
}

export default CDSectionMobile